module.exports = __webpack_public_path__ + "img/emoji_hot_face.e97fb7c2.png";